import { supabase } from './supabase';
import type { RelationshipLink } from '../types/Entities';
import { listRelationshipsCore, createRelationshipCore, updateRelationshipCore, deleteRelationshipCore } from '@gv/core';

export type RelationshipRow = {
    id: string;
    contact_id: string;
    related_contact_id: string | null;
    related_name: string;
    related_avatar: string | null;
    relation: string;
    where_met: string | null;
    where_met_meta: any;
    when_met: string | null;
    notes: string | null;
    created_at?: string;
    updated_at?: string;
};

export async function listRelationships(contactId: string): Promise<RelationshipLink[]> {
    const rows = await listRelationshipsCore(supabase, contactId);
    return rows as unknown as RelationshipLink[];
}

export async function createRelationship(contactId: string, link: RelationshipLink): Promise<RelationshipLink> {
    const saved = await createRelationshipCore(supabase, contactId, link as any);
    return saved as unknown as RelationshipLink;
}

export async function updateRelationship(id: string, link: RelationshipLink): Promise<RelationshipLink> {
    const updated = await updateRelationshipCore(supabase, id, link as any);
    return updated as unknown as RelationshipLink;
}

export async function deleteRelationship(id: string): Promise<void> {
    await deleteRelationshipCore(supabase, id);
}
